<template>
  <v-card outlined class="rounded-xl">
    <!-- Toolbar -->
    <v-toolbar flat dense color="grey lighten-4">
      <v-toolbar-title class="subtitle-1 font-weight-regular">
        {{ $t("pageHeader.invites") }}
      </v-toolbar-title>
    </v-toolbar>

    <!-- Invite Form -->
    <v-container grid-list-lg>
      <v-card outlined class="rounded-xl">
        <v-card-text>
          <v-row v-if="!hideCreate" align="center">
            <v-col cols="12" sm="8" md="6">
              <v-text-field
                v-model.trim="inviteEmail"
                label="Email"
                :error-messages="inviteEmailErrors"
                clearable
                dense
                outlined
              />
            </v-col>
            <v-col cols="12" sm="4" md="2">
              <v-btn block color="primary" @click="sendInvite"> Invite </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-container>

    <!-- Invites Table -->
    <v-card-text class="mt-0">
      <v-data-table
        :headers="headers"
        :items="invites"
        :options.sync="pagination"
        :server-items-length="count"
        :loading="loading"
        :items-per-page="pagination.rowsPerPage"
        class="elevation-1"
      >
        <template v-slot:item.createdAt="{ item }">
          {{ $moment(item.createdAt).format("MM/DD/YY") }}
        </template>

        <template v-slot:item.to="{ item }">
          {{ item.to }}
        </template>

        <template v-slot:item.status="{ item }">
          {{ item.status.toLowerCase() }}
        </template>

        <template v-slot:item.action="{ item }">
          <v-menu bottom left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on">
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>

            <v-list dense>
              <v-list-item @click="deleteInvite(item)">
                <v-list-item-title>{{
                  $t("buttons.delete")
                }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import userService from "../service";
import { validationMixin } from "vuelidate";
import { required, email } from "vuelidate/lib/validators";

export default {
  name: "user-invite",
  props: ["hideCreate"],
  data() {
    return {
      headers: [
        { text: this.$t("labels.date"), value: "createdAt", sortable: true },
        { text: this.$t("labels.email"), value: "to", sortable: false },
        { text: this.$t("labels.status"), value: "status", sortable: false },
        { text: "", value: "action", sortable: false },
      ],
      inviteEmail: null,
      invites: [],
      count: 0,
      loading: false,
      pagination: {
        page: 1,
        rowsPerPage: 10,
        sortBy: "createdAt",
        descending: true,
      },
    };
  },
  created() {
    this.getList();
  },
  computed: {
    inviteEmailErrors() {
      const errors = [];
      if (!this.$v.inviteEmail.$dirty) return errors;
      if (!this.$v.inviteEmail.required) errors.push("Field is required");
      if (!this.$v.inviteEmail.email) errors.push("Email is not valid");
      return errors;
    },
  },
  watch: {
    pagination: {
      handler() {
        this.getList();
      },
      deep: true,
    },
  },
  methods: {
    sendInvite() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.$toasted.error(this.$t("toastMessage.text.invalidFields"), {
          position: "top-right",
          showHideTransition: "slide",
          duration: 3500,
        });
        return;
      }

      userService
        .sendInvite({ email: this.inviteEmail })
        .then(() => {
          this.getList();
          this.inviteEmail = null;
        })
        .catch((error) => {
          this.$toasted.error(error.data, {
            position: "top-right",
            showHideTransition: "slide",
            duration: 3500,
          });
        });
    },
    async getList() {
      this.loading = true;
      const { page, rowsPerPage, sortBy, descending } = this.pagination;
      const offset = rowsPerPage * (page - 1);

      try {
        const response = await userService.getInvites({
          limit: rowsPerPage,
          offset,
          orderBy: [sortBy, descending],
          status: "pending",
        });
        this.invites = response.data;
        this.count = response.count;
      } finally {
        this.loading = false;
      }
    },
    deleteInvite(invite) {
      this.$swal({
        title: this.$t("messages.title.areYouSure"),
        text: this.$t("messages.text.youWontBeAbleToRevert"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: this.$t("buttons.cancel"),
        confirmButtonText: this.$t("buttons.yesDeleteIt"),
      })
        .then((result) => {
          if (result.value) {
            userService.revokeInvite(invite.id).then((response) => {
              if (response.data) {
                this.$swal(
                  this.$t("messages.title.deleted"),
                  this.$t("messages.text.inviteWasRevoked"),
                  "success"
                );
                this.getList();
              }
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  mixins: [validationMixin],
  validations: {
    inviteEmail: { required, email },
  },
};
</script>